import { useState } from 'react';

import { HollowedButton, NormalButton } from '@shared/designSystem/Button';
import { HorizontalContainer, VerticalContainer } from '@shared/designSystem/Containers';
import { ModalHeader } from '@shared/designSystem/ModalHeader';
import { ToastManager } from '@shared/designSystem/messages/ToastManager';
import { Text } from '@shared/designSystem/Texts';
import designSystemStyles from '@shared/styles/designSystemStyles';

import { usePopup } from '@contexts/popupContext';
import { Application } from '@core/Application';
import ResultPopup from '@components/General/ResultPopup';
import { UsersService } from '@services/UsersService';

const DesactivarColaborador = ({ row, colaborador, onDone, orgID }) => {
    const { hidePopup, showPopup } = usePopup();
    const [loading, setLoading] = useState(false);

    const handleDesactivarUsuario = async () => {
        setLoading(true);
        try {
            const usersService = new UsersService(Application.shared().coreDependencies.httpClient);
            await usersService.deactivateUser(orgID, row.id);

            hidePopup();
            ToastManager.shared().showSuccessMessage(`${colaborador} desactivado exitosamente`);
            onDone();
        } catch (error) {
            showPopup(() => <ResultPopup result={"Error al desactivar usuario"} succesful={false} />);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                width: '520px',
                maxWidth: '92vw',
                backgroundColor: 'white',
                borderRadius: '20px',
                overflow: 'hidden',
                fontFamily: designSystemStyles.fontFamily,
            }}
        >
        <VerticalContainer
            width="100%"
            backgroundColor="white"
            borderRadius="20px"
            gap={designSystemStyles.gapNone}
        >
            <div
                style={{
                    width: '100%',
                    padding: designSystemStyles.paddingLg,
                    borderBottom: `1px solid ${designSystemStyles.colorTextInputBorder}`,
                    boxSizing: 'border-box',
                }}
            >
                <ModalHeader title={'Desactivar colaborador'} onClose={hidePopup} />
            </div>

            <VerticalContainer
                width="100%"
                padding={designSystemStyles.paddingLg}
                gap={designSystemStyles.gapLg}
                alignment="left"
            >
                <Text
                    text={`¿Estás seguro de que deseas desactivar a **${(colaborador ?? '').trim()}**?`}
                    markdown={true}
                    color={designSystemStyles.colorText}
                />

                 <HorizontalContainer justifyContent="flex-end" width="100%" gap={designSystemStyles.gapSm}>
                     <HollowedButton
                         text={'Cancelar'}
                        onClick={hidePopup}
                        disabled={loading}
                         width="140px"
                     />

                    <NormalButton
                        text={'Desactivar'}
                        onClick={handleDesactivarUsuario}
                        loading={loading}
                        width="160px"
                    />
                </HorizontalContainer>
            </VerticalContainer>
        </VerticalContainer>
        </div>
    );
};

export default DesactivarColaborador;
